import React from 'react'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'
import {useGetGenericHtmlPage} from '../../custom-api/hooks/use-get-generic-html-page'
import {Helmet} from 'react-helmet'
import loadable from '@loadable/component'
import {Box, useMediaQuery} from '@chakra-ui/react'
import {remCalc} from '../../../../plugins/px-to-rem-babel-custom-plugin/utils/remCalc'
import SanitizedHtml from '../../components/html-sanitizer'

const PageNotFound = loadable(() => import('./../page-not-found'))

const GenericHtmlPage = () => {
    const {res} = useServerContext()
    const {data, error, isLoading} = useGetGenericHtmlPage()
    const entries = {...data}
    const [isWidescreen] = useMediaQuery(`(min-width: ${remCalc(1400)})`)

    if (error || (data === null && !isLoading)) {
        if (res) res.status(404)
        return <PageNotFound />
    }

    const seo = entries?.seo_standard || {}
    const metaTitle = seo?.meta_title
    const metaDescription = seo?.meta_description

    return (
        <>
            <Helmet>
                {metaTitle && <title>{metaTitle}</title>}
                {metaDescription && <meta name="description" content={metaDescription} />}
            </Helmet>
            <link
                rel="stylesheet"
                href="https://ecomm-apps.delonghigroup.com/legacy-terms-bundle.css"
            />
            <Box
                maxW={1400}
                width="100%"
                p={isWidescreen ? `${remCalc(24)} 0` : remCalc(24)}
                mx={'auto'}
            >
                <SanitizedHtml as="div" html={data?.html} />
            </Box>
        </>
    )
}

export default GenericHtmlPage
